import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const appConfigFields = {
  id: true,
  appName: true,
  logo: true,
  favicon: true,
  primaryColor: true,
  accentColor: true,
  headingFont: true,
  bodyFont: true,
  footerText: true,
  defaultLocale: true,
  brandingLocked: true,
  // Accroche d'acquisition sur l'écran de connexion (#216) : servie ici parce
  // que la décision se prend pré-auth, comme le branding.
  signupCtaVisible: true,
  // Fuseau de l'org (#194) : toute borne de parcours se relit dedans, pas dans
  // celui du navigateur. Servi ici parce que cette query est déjà chargée
  // globalement, avant login compris.
  timezone: true,
} as const

export const GQL_APP_CONFIG = typedGql('query', { scalars })({
  appConfig: appConfigFields,
})

export const GQL_UPDATE_APP_CONFIG = typedGql('mutation')({
  updateAppConfig: [
    {
      input: $('input', 'UpdateAppConfigInput!'),
    },
    appConfigFields,
  ],
})
